<template>
    <v-container fluid>
        <v-row class="paddigMobile">
            <v-col cols="12" md="6">
                <h1 style="color:#ff770fe0">Produtos</h1>

            </v-col>
            <v-col cols="12" md="6" style="flex-direction: row-reverse; display: flex;">
                <v-btn @click="cadastroProdutos = true" class="StyleButton">Adicionar novo produto</v-btn>
            </v-col>

            <v-col cols="12" md="12">
                <v-data-table v-model="selected" :headers="headers" :items="desserts" item-key="id" show-select
                    class="elevation-1">
                    <!-- <template v-slot:[`item.img`]="{ item }">
                        <v-img contain width="100px" :src="require('../assets/produtos/' + item.img)"></v-img>
                    </template> -->
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog class="d-flex justify-center align-center " fullscreen hide-overlay
            transition="dialog-bottom-transition" v-model="cadastroProdutos">
            <v-card class="d-flex justify-center flex-column align-center padMobile" style="padding: 20px 60px">
                <v-btn icon color="white" style="position: absolute; right: 15px; top: 15px;"
                    @click="cadastroProdutos = false">
                    <v-icon color="black">mdi-close</v-icon>
                </v-btn>
                <v-row class="bgcHomeRibus paddingMobile" style="padding: 44px 64px 0px; width: 100%;">
                    <v-col cols="12" md="10" class="d-flex justify-center algin-center flex-column">
                        <h1 class="titleScope" style="color: #FF770F; font-size: 58px; text-transform: uppercase;">
                            CADASTRE UM NOVO PRODUTO!</h1>
                        <p class="textScope">Preencha as informações. Capriche nas fotos!</p>
                    </v-col>
                    <v-col cols="12" md="6" class="" style="background-color: #ffffffe8; padding: 20px">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col style="padding: 0 12px !important;" cols="12" md="12">
                                    <v-row>
                                        <v-col style="padding: 0 12px !important;" cols="12" md="12">
                                            <v-text-field label="Título" placeholder="" outlined></v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0 12px !important;" cols="12" md="6">
                                            <v-text-field label="Valor" placeholder="" outlined></v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0 12px !important;" cols="12" md="6">
                                            <v-text-field label="Valor com desconto" placeholder="" outlined>
                                            </v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0 12px !important;" cols="12" md="6">
                                            <v-text-field label="Tipo" placeholder="" outlined></v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0 12px !important;" cols="12" md="12">
                                            <v-text-field label="Descrição curta" placeholder="" outlined>
                                            </v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0 12px !important;" cols="12" md="12">
                                            <v-textarea name="input-7-1" label="Descrição completa" value=""
                                                hint="Hint text">
                                            </v-textarea>
                                        </v-col>                                       

                                        <v-col style="padding: 0 12px !important;" cols="12" md="12">
                                            <v-checkbox v-model="checkbox2" label="Produto inativo"></v-checkbox>
                                        </v-col>
                                        <v-btn style="margin-top: 20px" class="StyleButton" block>Cadastrar</v-btn>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-file-input label="Adicionar imagens" multiple class="mx-auto" chips
                                    prepend-icon="mdi-file-plus" v-model="files">
                                </v-file-input>
                            </v-col>

                            <v-col v-for="(img, i) in imagens" :key="img.foto" cols="12" :md="i in [1, 1] ? '3' : '3'"
                                class="padding2px">
                                <!-- <v-img :src="require(`@/assets/produtos/${img.foto}`)"></v-img> -->
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            cadastroImovel: false,
            valid: false,
            checkbox2: '',
            files: [],
            cadastroProdutos: false,
            selected: [],
            imagens: [
                // { foto: 'produto1.webp' },
                { foto: 'produto2.webp' },
                { foto: 'produto3.webp' },
                { foto: 'produto4.webp' },
                { foto: 'produto4.1.webp' },
            ],
            headers: [
                {
                    text: 'Imagem',
                    align: 'start',
                    sortable: false,
                    value: 'img',
                },
                { text: 'Titulo', value: 'local' },
                { text: 'Porcentagem de ribus', value: 'data' },
                { text: 'Valor', value: 'valor' },
                { text: 'Valor promocional', value: 'responsavel' },
            ],
            desserts: [
                {
                    id: 0,
                    img: 'produto1.webp',
                    local: 'Smarthpone',
                    data: '30%',
                    valor: 'R$1.259,00',
                    responsavel: 'R$1.090,00',
                },
                {
                    id: 1,
                    img: 'produto2.webp',
                    local: 'Console',
                    data: '50%',
                    valor: 'R$1.949,90',
                    responsavel: 'R$1.749,90',
                },
                {
                    id: 2,
                    img: 'produto3.webp',
                    local: 'Fratadeira sem óleo',
                    data: '90%',
                    valor: 'R$369,00',
                    responsavel: 'R$310,00',
                },
                {
                    id: 3,
                    img: 'produto4.webp',
                    local: 'Caneca Stanley',
                    data: '100%',
                    valor: 'R$180,00',
                    responsavel: 'R$170,00',
                },
                {
                    id: 4,
                    img: 'produto4.1.webp',
                    local: 'Caneca Stanley',
                    data: '100%',
                    valor: 'R$180,00',
                    responsavel: 'R$110,00',
                },
            ],
        }
    },
    methods: {
        requireImg(img) {
            return require(`../assets/${img}`);
        }
    }
}
</script>